import { GFCUser, GFCDescription, GFCTimestamp, GFCNotes, GFCStatus, GFCMore } from "./GridFramework";

export const columnDef = [
    {
        headerName: "Client",
        field: "Name",
        sortable: true,
        width: 300,
        cellRenderer: GFCUser,
        autoHeight: true,
        headerStyle: { paddingLeft: "24px" },
        cellStyle: { paddingLeft: "24px", whiteSpace: "normal" },
    },
    {
        headerName: "Description",
        field: "Name",
        sortable: true,
        minWidth: 200,
        autoHeight: true,
        flex: 1,
        cellStyle: { whiteSpace: "normal", display: "flex" },
        cellRenderer: GFCDescription,
    },
    {
        headerName: "Due on",
        field: "EstimatedEndDate",
        sortable: true,
        width: 150,
        cellRenderer: GFCTimestamp,
    },
    {
        headerName: "Notes",
        field: "Notes",
        width: 80,
        cellRenderer: GFCNotes,
    },
    {
        headerName: "Status",
        field: "Status",
        width: 140,
        cellRenderer: GFCStatus,
    },
    {
        headerName: "More",
        field: "Id",
        width: 70,
        cellRenderer: GFCMore,
    },
];
